export default {
  lpStaking: {
    minimumAmount: "최소 스테이킹: {amount} USDT",
    amountTooLow: "최소 {amount} USDT를 스테이킹하세요",
    minimumLoading: "최소 스테이킹 금액을 불러오는 중",
    minimumFailed: "최소 스테이킹 금액을 사용할 수 없습니다. 다시 시도하세요.",
    confirmationDelayed: "온체인 확인이 진행 중입니다. 스테이킹 상태를 직접 새로고침하고 다시 결제하지 마세요.",
    statusUnknown: "상태 확인 불가",
    refreshStaked: "스테이킹 상태 새로고침",
    paid: "스테이킹 확인 완료",
    unpaid: "결제 대기",
    confirming: "온체인 확인 대기",
    contractPending: "LP 계약 배포 전입니다. 스테이킹할 수 없습니다.",
    orderInvalid: "주문 데이터가 잘못되었습니다. 스테이킹 내역을 먼저 확인하세요.",
    walletRequired: "먼저 지갑을 연결하세요",
    wrongNetwork: "올바른 네트워크로 전환하세요",
    accountChanged: "지갑 계정이 변경되었습니다. 다시 로그인하세요.",
    signatureRejected: "지갑 작업이 취소되었습니다",
    submitFailed: "제출하지 못했습니다. 다시 시도하세요.",
    retryHash: "거래 Hash 재제출",
    hashRetryHint: "거래가 전송되었습니다. Hash 제출만 재시도하고 다시 결제하지 마세요.",
    paymentUncertain: "거래 상태를 확인해야 합니다. 다시 결제하기 전에 내역을 확인하세요.",
    orderNumber: "주문 번호",
    transactionHash: "거래 Hash",
    refreshRecords: "새로고침",
    retry: "다시 시도",
    noRecords: "내역이 없습니다",
    recordsFailed: "내역을 불러오지 못했습니다. 다시 시도하세요.",
    stakingIncome: "스테이킹 수익",
    loadMore: "더 보기",
    ordersPending: "스테이킹 내역을 일시적으로 사용할 수 없습니다",
    title: "LP 스테이킹",
    staked: "스테이킹한 USDT",
    stakeUsdt: "USDT 스테이킹",
    walletBalance: "지갑 USDT 잔액",
    refreshBalance: "지갑 잔액 새로고침",
    amount: "스테이킹 수량",
    amountPlaceholder: "스테이킹 수량을 입력하세요",
    amountHint: "금액을 선택하거나 직접 입력하세요",
    confirm: "스테이킹 확인",
    stakingPending: "스테이킹 기능 연동 예정",
    dataPending: "데이터 연동 예정",
    unavailable: "사용 불가",
    balanceFailed: "지갑 잔액을 불러오지 못했습니다. 다시 시도하세요.",
    amountRequired: "스테이킹 수량을 입력하세요",
    amountInvalid: "0보다 큰 유효한 금액을 입력하세요",
    insufficient: "지갑 USDT 잔액이 부족합니다",
    records: "내 스테이킹 내역",
    ranking: "전체 스테이킹 순위",
    earnings: "수익 내역",
    recordsDescription: "내 개별 스테이킹 내역",
    rankingDescription: "지갑별 누적 스테이킹 금액순",
    rankingHint: "동일 지갑의 여러 스테이킹을 합산합니다",
    earningsDescription: "각 수익 내역 확인",
    back: "LP 스테이킹으로 돌아가기",
    recordLinks: "내역 메뉴",
  },
  确认: "확인",
  取消: "취소",
  选择语言: "언어 선택",
  切换语言成功: "언어 전환 성공",
  首页: "홈",
  采购: "보고서 등록",
  团队: "팀",
  "交易进行中,请勿进行其他操作":
    "거래가 진행 중입니다. 다른 작업은 하지 마세요.",
  资金管理: "자금 관리",
  资金明细: "자금 상세",
  我的订单: "내 주문",
  订单详情: "주문 상세",
  没有更多了: "더 이상 없습니다",
  加载中: "로딩 중",
  代币价格: "토큰 가격",
  收益概览: "수익 개요",
  申购收益: "신청 수익",
  分享收益: "공유 수익",
  官方网站: "공식 웹사이트",
  官网: "공식 웹사이트",
  电报: "텔레그램",
  推特: "트위터",
  白皮书: "백서",
  申购金额: "신청 금액",
  请输入入金金额: "입금 금액을 입력하세요",
  快捷申购: "빠른 신청",
  申购比例: "신청 비율",
  赠币数量: "증정 토큰 수량",
  立即申购: "지금 신청",
  更多: "더 보기",
  订单: "주문",
  分红中: "배당 중",
  已完成: "완료",
  累计分红: "누적 배당",
  申购信息: "신청 정보",
  兑换数量: "환전 수량",
  赠币数量: "증정 토큰 수량",
  开始时间: "시작 시간",
  提现成功: "출금 성공",
  确认: "확인",
  订单编号: "주문 번호",
  团队数据总览: "팀 데이터 개요",
  我的推广链接: "내 프로모션 링크",
  复制: "복사",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "이 링크를 공유하여 친구를 팀에 초대하고 프로모션 보상을 받으세요",
  团队业绩: "팀 실적",
  当前等级: "현재 레벨",
  今日收益: "오늘의 수익",
  申购收益: "신청 수익",
  分享收益: "공유 수익",
  团队用户: "팀 사용자",
  有效团队: "유효 팀",
  有效用户: "유효 사용자",
  无效团队: "무효 팀",
  直推用户: "직접 추천 사용자",
  有效直推: "유효 직접 추천",
  无效直推: "무효 직접 추천",
  资产余额数据概览: "자산 잔액 데이터 개요",
  提现: "출금",
  选中币种: "선택한 화폐",
  请输入入金金额: "입금 금액을 입력하세요",
  提现数量: "출금 수량",
  确认提现: "출금 확인",
  资金明细: "자금 상세",
  分红收入: "배당 수입",
  直推奖励: "직접 추천 보상",
  团队奖励: "팀 보상",
  申购金额: "신청 금액",
  兑换数量: "환전 수량",
  赠币数量: "증정 토큰 수량",
  开始时间: "시작 시간",
  立即申购: "지금 신청",
  确认: "확인",
  全部: "전체",
  收入: "수입",
  支出: "지출",
  请输入正确的金额: "올바른 금액을 입력하세요",
  申购成功: "신청 성공",
  申购失败: "신청 실패",
  提现失败: "출금 실패",
  提现信息: "출금 정보",
  提现币种: "출금 화폐",
  提现数量: "출금 수량",
  请选择币种: "화폐를 선택하세요",
  钱包余额不足: "지갑 잔액 부족",
  余额不足: "잔액 부족",
  提现手续费: "출금 수수료",
  间推奖励: "간접 추천 보상",
  团队奖励: "팀 보상",
  提现失败退还: "출금 실패 환불",
  ido申购: "IDO 신청",
  ido申购赠送: "IDO 신청 증정",
  链式去中心化全球点火网络: "체인 기반 탈중앙화 글로벌 이그니션 네트워크",
  协议永生: "프로토콜 영생",
  智能涌现: "지능 탄생",
  财富觉醒: "재산 각성",
  立即进入: "지금 입장",
  大区累计业绩: "대구역 누적 실적",
  小区累计业绩: "소구역 누적 실적",
  复制成功: "복사 성공",
  复制失败: "복사 실패",
  暂无数据: "데이터 없음",
  当DeFi遇上自主型DAO: "DeFi가 자율형 DAO를 만났을 때",
  历史最高: "역대 최고",
  历史最低: "역대 최저",
  当前价格: "현재 가격",
  采购累计收益: "보고서 등록 누적 수익",
  团队累计收益: "팀 누적 수익",
  采购金额: "보고서 등록 금액",
  快捷采购: "빠른 보고서 등록",
  请输入采购金额: "보고서 등록 금액을 입력하세요",
  采购比例: "보고서 등록 비율",
  采购信息: "보고서 등록 정보",
  进行中: "진행 중",
  已完成: "완료",
  累计收益: "누적 수익",
  立即采购: "지금 보고서 등록",
  请输入提现数量: "출금 수량을 입력하세요",
  提现确认: "출금 확인",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "이번 출금의 체인상 Gas 수수료는 본인 부담입니다. 확인을 클릭하면 출금 절차가 진행되며, 출금 잔액이 우선 차감됩니다.",
  "操作后无法撤销，请谨慎认购":
    "작업 후에는 취소할 수 없습니다. 신중하게 구매하세요",
  我再想想: "다시 생각해볼게요",
  确认提现: "출금 확인",
  余额不足: "잔액 부족",
  直推奖励: "직접 추천 보상",
  团队奖励: "팀 보상",
  提现失败退还: "출금 실패 환불",
  平级收益: "동급 수익",
  每日释放: "매일 해제",
  提现TDL: "TDL 출금",
  采购失败: "보고서 등록 실패",
  绑定邀请人: "초대자 바인딩",
  采购成功: "보고서 등록 성공",
  提现比例: "출금 비율",
  入金支付说明: "입금 지불 설명",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "실제 지불 금액은 두 부분으로 구성되며, 현재 지불 비율에 따라 계산됩니다",
  支付TDL数量: "TDL 지불 수량",
  入金数量: "입금 수량",
  TDL支付比例: "TDL 지불 비율",
  "注：支付比例由平台设定，可能随时调整":
    "참고: 지불 비율은 플랫폼에서 설정하며, 언제든지 변경될 수 있습니다",
  我知道了: "알겠습니다",
  支付USDT数量: "USDT 지불 수량",
  USDT支付比例: "USDT 지불 비율",
  TDL实时价格: "TDL 실시간 가격",
  请先连接TCC链: "먼저 TCC 체인에 연결하세요",
  收益中: "수익 중",
  世界华人的GDT: "세계 한류 GDT",
  当Defi遇上自主型DAO: "DeFi가 자율형 DAO를 만났을 때",
  提现GGC: "GGC 출금",
  支付GGC数量: "GGC 지불 수량",
  GGC支付比例: "GGC 지불 비율",
  GGC实时价格: "GGC 실시간 가격",
  兑换: "환전",
  兑换比例: "환전 비율",
  兑换数量: "환전 수량",
  确认兑换: "환전 확인",
  请输入兑换数量: "환전 수량을 입력하세요",
  兑换失败退还: "환전 실패 환불",
  兑换GGC: "환전 GGC",
  请输入采购方式: "보고서 등록 방법을 입력하세요",
  余额采购: "잔액 보고서 등록",
  钱包采购: "지갑 보고서 등록",
  资产余额: "자산 잔액",
  资产明细: "자산 상세",
  余额支付: "잔액 지불",
  商城划转: "쇼핑몰 이동",
  商城划转GGC: "쇼핑몰 이동 GGC",
  采购收益GGC: "보고서 등록 수익 GGC",
  采购方式: "보고서 등록 방법",
  采购数量: "보고서 등록 수량",
  链上全球购余额: "체인상 글로벌 이그니션 잔액",
  全球购划转USDT: "글로벌 이그니션 USDT 이동",
  全球购划转GGC: "글로벌 이그니션 GGC 이동",
  生态合成: "생태 합성",
  合成数量: "합성 수량",
  合成方式: "합성 방법",
  快捷合成: "빠른 합성",
  合成比例: "합성 비율",
  点击更多更多订单里面还有: "더 많은 주문이 있습니다",
  合成信息: "합성 정보",
  合成累计收益: "합성 누적 수익",
  收益统计: "수익 통계",
  请输入合成数量: "합성 수량을 입력하세요",
  请输入合成方式: "합성 방법을 입력하세요",
  合成说明: "합성 설명",
  "50％GGC": "50% GGC",
  "50％GGC价值U": "50% GGC 가치의 U",
  GDT链GGC余额: "GDT 체인 GGC 잔액",
  GDT链USDT余额: "GDT 체인 USDT 잔액",
  支付GGC: "GGC 결제량",
  支付USDT: "USDT 결제량",
  获取钱包余额失败: "지갑 잔액을 가져오지 못했습니다",
  全球购余额: "글로벌구매잔액",
  钱包余额: "지갑 잔액",
  全球购划转余额: "글로벌구매이체잔액",
  采购奖励USDT: "보고서 등록 보상 USDT",
  贸易额度奖励GGC: "取引 보상 GGC",
  可变现GGC2数量: "사용 가능한 GGC2 수량",
  警告: "경고",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数":
    "GGC 가치와 동일한 U 합성을 구성해야 하며, hanhanh는 GGC 양의 두 배로 방출됩니다.",
  量释放: "량 해제",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数量释放":
  "GGC 가치와 동일한 U 합성을 구성해야 하며, hanhanh는 GGC 양의 두 배로 방출됩니다.",
  该项业务不为中国用户提供任何服务:
    "해당 서비스는 중국 사용자에게 어떠한 서비스도 제공하지 않습니다.",
  "返回到钱包主页面,即可查阅到生态合成所支付的各项明细(包含：GGC、GDT、USDT)":
    "지갑 메인 페이지에서 생태 합성 지불 내역을 확인할 수 있습니다. (GGC, GDT, USDT)",
};
